import React, { Component } from 'react';
import IconNewWindow from '../atoms/IconNewWindow';

class LocationEnlistees extends Component {
    render() {
      if(this.props.locationData.enlistees.nodes.length > 0) {
        return (
          <div className="LocationEnlistees">
            <h2 className="h4">Enlistees from {this.props.locationData.title}</h2>
            {this.props.locationData.enlistees.nodes.map( ( enlistee, i ) => (
              <a key={i} className="enlistee" href={enlistee.node.aif_profile_link} target="_blank" rel="noopener noreferrer">
                <p className="enlisteeName"><span className="lastName">{enlistee.node.family_name}</span>, {enlistee.node.given_name}</p>
                <button className="iconButton" type="button"><IconNewWindow/></button>
              </a>
            ) )}
          </div>
        )
      } else {
        return null;
      }

    }
}

export default LocationEnlistees;